export const Header ={
  pic: 'https://p2.ssl.qhimg.com/t0196f4b36981d77e45.png',
  alt: '头图',
}
export const Desc ={
  pic: 'https://p3.ssl.qhimg.com/t011dd19b678139beff.png',
  alt: '描述',
}

export const Block={
  pic: 'https://p0.ssl.qhimg.com/t01a7a688d1ae088b9b.png',
  alt: '板块设置'
}

export const Light = {
  pic: 'https://p2.ssl.qhimg.com/t01091b315d6109da22.png',
  alt: '亮点'
}

export const Plate = {
  pic: 'https://p5.ssl.qhimg.com/t01d00efb1a12fdd8f2.png',
  alt: '板块'
}

export const About = {
  pic: 'https://p5.ssl.qhimg.com/t014f59705b1ce2d94b.png',
  alt: '关于我们'
}

export const Tickets = [
  {
    id:0,
    pic: 'https://p1.ssl.qhimg.com/t01de49907a10b3fdac.png',
    alt: '1790',
    url: 'https://isc360.shop.6360.cn/detail.html?id=82194&skuId=106599'
  },
  {
    id:1,
    pic: 'https://p5.ssl.qhimg.com/t01ba28a593bdbbadf6.png',
    alt: '5980',
    url: 'https://isc360.shop.6360.cn/detail.html?id=82195&skuId=106600'
  },
  {
    id: 2,
    pic: 'https://p0.ssl.qhimg.com/t01220bdf8f4516c485.png',
    alt: '15800',
    url: 'https://isc360.shop.6360.cn/detail.html?id=82196&skuId=106601'
  },
  {
    id: 3,
    pic: 'https://p1.ssl.qhimg.com/t01263e8030caa10a15.png',
    alt: '2880',
    url: 'https://isc360.shop.6360.cn/detail.html?id=82197&skuId=106602'
  },
  {
    id: 4,
    pic: 'https://p0.ssl.qhimg.com/t01fcd474e48975a648.png',
    alt: '1980',
    url: 'https://isc360.shop.6360.cn/detail.html?id=82198&skuId=106603'
  },
  {
    id: 5,
    pic: 'https://p2.ssl.qhimg.com/t01dceab1b7f28eb42a.png',
    alt: '680',
    url: 'https://isc360.shop.6360.cn/detail.html?id=82200&skuId=106605'
  }
]

export const Togther = {
  pic: 'https://p0.ssl.qhimg.com/t01729b5306a0edb91f.png',
  alt: '参与议题与共创'
}
export const Btn = {
  pic: 'https://p0.ssl.qhimg.com/t0186f916906cf054b7.png',
  alt: '购票按钮',
  url: 'https://isc360.shop.6360.cn/detail.html?id=82778&skuId=108574'
}
